import pImg1 from '../images/portfolio/portfolio_item_image_1.webp'
import pImg2 from '../images/portfolio/portfolio_item_image_2.webp'
import pImg3 from '../images/portfolio/portfolio_item_image_3.webp'
import pImg4 from '../images/case/case_image_1.webp'
import pImg5 from '../images/case/case_image_2.webp'
import pImg6 from '../images/case/case_image_3.webp'

import pImg7 from '../images/portfolio/portfolio_item_image_4.webp'
import pImg8 from '../images/portfolio/portfolio_item_image_5.webp'
import pImg9 from '../images/portfolio/portfolio_item_image_6.webp'
import pImg10 from '../images/portfolio/portfolio_item_image_7.webp'
import pImg11 from '../images/portfolio/portfolio_item_image_8.webp'
import pImg12 from '../images/portfolio/portfolio_item_image_9.webp'
import pImg13 from '../images/portfolio/portfolio_item_image_10.webp'
import pImg14 from '../images/portfolio/portfolio_item_image_11.webp'

import tImg1 from '../images/case/icon_angular.svg'
import tImg2 from '../images/case/icon_elephent.svg'
import tImg3 from '../images/case/icon_netcore.svg'
import tImg4 from '../images/case/vuejs.svg'
import tImg5 from '../images/case/icon_python.svg'

import Gunanusa from '../images/clients/gunanusa.png'
import adaro from '../images/clients/adaro.png'
import BukitAsam from '../images/clients/bukitasam.png'

const Project = [
    {
        Id: '1',
        pImg: pImg1,
        title: 'Mobile App Design',
        slug: 'Mobile-App-Design',
        sub: 'App Design',
        description: 'Our all-encompassing IELTS Coaching curriculum encompasses every aspect...',
    },
    {
        Id: '2',
        pImg: pImg2,
        title: 'TOEFL Coaching',
        slug: 'TOEFL-Coaching',
        sub: '',
        description: 'Our experienced coaches are not just educators; they are partners in your journey..',
    },
    {
        Id: '3',
        pImg: pImg3,
        title: 'Dashboard Design',
        slug: 'Dashboard-Design',
        sub: 'Web Design',
        description: 'The contents of the citizenship test typically cover a range of subjects ...',
    },
    {
        Id: '4',
        pImg: pImg1,
        title: 'Mobile App Design',
        slug: 'Mobile-App-Design',
        sub: 'App Design',
        description: 'Our all-encompassing IELTS Coaching curriculum encompasses every aspect...',
    },
    {
        Id: '5',
        pImg: pImg2,
        title: 'TOEFL Coaching',
        slug: 'TOEFL-Coaching',
        sub: '',
        description: 'Our experienced coaches are not just educators; they are partners in your journey..',
    },
    {
        Id: '6',
        pImg: pImg3,
        title: 'Dashboard Design',
        slug: 'Dashboard-Design',
        sub: 'Web Design',
        description: 'The contents of the citizenship test typically cover a range of subjects ...',
    },
    {
        Id: '7',
        pImg: Gunanusa,
        title: 'PT Gunanusa Utama Fabricators',
        slug: 'Gunanusa',
        sub: 'Construction',
        Industry: 'Constructions',
        Country: 'Indonesia, Banten',
        Technologies1: tImg1,
        Technologies2: tImg2,
        description: 'In 2026, the Ceragon radio microwave installation project at WHCPP Hidayah was successfully completed by our team at PT Gunanusa Utama Fabricators, Cilegon. This work ensures high-capacity data connectivity with strict adherence to safety standards and technical quality, supporting reliable communication across energy and fabrication projects.',
    },
    {
        Id: '8',
        pImg: BukitAsam,
        title: 'PT. Bukit Asam',
        slug: 'Bukit Asam',
        sub: 'Mining',
        Industry: 'Coal',
        Country: 'Indonesia, Sumatera',
        Technologies1: tImg1,
        Technologies2: tImg3,
        description: 'In 2026, PPL successfully delivered and implemented a Smart Surveillance & CCTV solution that serves not only as a monitoring system but is also fully integrated into the IT infrastructure ecosystem. In executing this project, PPL applied the flexibility of Custom Fabrication (Project-Locked), allowing the CCTV devices to be exclusively configured and customized to meet specific project requirements and standards. Powered by AI Surveillance technology, the deployed solution delivers predictive analysis and intelligent monitoring, thereby enhancing the effectiveness and efficiency of the security system within a single, integrated ecosystem.',
    },
    {
        Id: '9',
        pImg: adaro,
        title: 'ADARO Minerals (Kalimantan Alumunium Industry) Site Kalimantan',
        slug: 'adaro-minerals-kalimantan',
        sub: 'Mining',
        Industry: 'Minerals',
        Country: 'Indonesia, Kalimantan',
        Technologies1: tImg1,
        Technologies2: tImg2,
        description: 'In 2025, PPL successfully executed a Radio Local Link infrastructure project to support the connection.',
    },
    {
        Id: '10',
        pImg: pImg7,
        title: 'Driving Digital Transformation Explore the Depth of Our IT Projects',
        slug: 'Driving-Digital-Transformation-Explore-the-Depth-of-Our-IT Projects',
        thumb1: 'Logo Design',
        thumb2: 'Finance',
        category: 'technology',
    },
    {
        Id: '17',
        pImg: pImg8,
        title: 'Explore Our IT Solutions Portfolio for Public Sector Organizations',
        slug: 'Explore-Our-IT-Solutions',
        thumb1: 'App Design',
        thumb2: 'Public',
        category: 'helpdesk',
    },
    {
        Id: '18',
        pImg: pImg9,
        title: 'Innovative Solutions Showcase the Diversity of Our IT Portfolio',
        slug: 'Innovative-Solutions-Showcase-the-Diversity-of-Our-IT-Portfolio',
        thumb1: 'Card Design',
        thumb2: 'Transpiration',
        category: 'analysis',
    },
    {
        Id: '19',
        pImg: pImg10,
        title: 'Tech Triumphs Celebrating Our Achievements in IT Solutions',
        slug: 'Tech-Triumphs-Celebrating-Our-Achievements-in-IT-Solutions',
        thumb1: 'Web Design',
        thumb2: 'Logistic',
        category: 'technology',
    },
    {
        Id: '20',
        pImg: pImg11,
        title: 'Revolutionizing IT Strategies A Closer Look at Our Dynamic IT Solutions',
        slug: 'Revolutionizing-IT-Strategies-A-Closer-Look-at-Our-Dynamic-IT-Solutions',
        thumb1: 'Web Design',
        thumb2: 'Fution',
        category: 'analysis',
    },
    {
        Id: '21',
        pImg: pImg12,
        title: 'Cloud Migration and Integration Project IT Solutions Portfolio',
        slug: 'Cloud-Migration-and-Integration-Project-IT-Solutions-Portfolio',
        thumb1: 'Web Design',
        thumb2: 'Energy',
        category: 'helpdesk',
    },
    {
        Id: '22',
        pImg: pImg13,
        title: 'Pioneering Progress Exploring the Evolution and Impact of',
        slug: 'Pioneering-Progress-Exploring-the-Evolution-and-Impact-of',
        thumb1: 'Web Design',
        thumb2: 'Health',
        category: 'marketing',
    },
    {
        Id: '23',
        pImg: pImg14,
        title: 'Unlocking Potential Explore Our Comprehensive IT Portfolio',
        slug: 'Unlocking-Potential-Explore-Our-Comprehensive-IT-Portfolio',
        thumb1: 'Web Design',
        thumb2: 'Industry',
        category: 'technology',
    },
]

export default Project;
